<template>
    <div class="big_box">
        <!-- ========== INLINE 模式（和 metalPurifyRpt.vue 完全一致） ========== -->
        <div v-if="filterMode === 'inline'" class="header_warpper">
            <div class="left">
                <el-form
                    :model="form"
                    :rules="computedRules"
                    ref="ruleForm"
                    label-position="top"
                    :inline="true"
                    style="display: flex; flex-wrap: wrap;"
                >
                    <template v-for="(item, index) in allArr.item">
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style=""
                            :key="index"
                            v-if="(item.type == 'select' || item.type == 'select-multiple') && item.status == 1"
                        >
                            <mySelectOptimized
                                v-model="form[item.item_no]"
                                :options="allArr.value[item.item_no.replace('_no', '')] || []"
                                :values="item.item_no.replace('_no', '') + '_no'"
                                :labels="item.item_no.replace('_no', '') + '_name'"
                                :keys="item.item_no.replace('_no', '') + '_no'"
                                :multiple="item.type == 'select-multiple'"
                                :clearables="true"
                                :placeholders="'请选择' + item.item_name"
                                size="mini"
                                @selectChange="changeData(item, item.type)"
                                @clear="handleClear(item)"
                                style="width: 100%"
                            />
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style=""
                            :key="'i' + index"
                            v-else-if="(item.type == 'number' || item.type == 'text') && item.status == 1"
                        >
                            <el-input
                                v-model="form[item.item_no]"
                                :type="item.type"
                                :placeholder="'请输入' + item.item_name"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            v-else-if="item.type == 'switch' && item.status == 1"
                            :key="'s' + index"
                            style=""
                        >
                            <el-tag :type="form[item.item_no] == '1' ? 'success' : form[item.item_no] == '0' ? 'danger' : ''">{{
                                form[item.item_no] == 1 ? '是' : '否'
                            }}</el-tag>
                            <el-switch style="margin-left: 5px" v-model="form[item.item_no]" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :key="'d' + index"
                            :label="item.item_name"
                            style=""
                            v-else-if="item.status == 1 && ['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)"
                        >
                            <el-date-picker
                                v-bind="getDatePickerProps(item)"
                                v-model="form[item.item_no]"
                                @blur="(value) => getTimes(value, item)"
                                @change="(value) => changeTime(value, item)"
                            />
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div class="right">
                <el-button @click="searchIt">{{ $t('common.search') }}</el-button>
                <el-button @click="outExcel">{{ $t('common.export') }}</el-button>
            </div>
        </div>

        <!-- ========== DRAWER 模式 ========== -->
        <div v-else-if="filterMode === 'drawer'" class="header_warpper">
            <div class="left">
                <el-form
                    :rules="computedRules"
                    :model="form"
                    ref="ruleForm"
                    label-position="top"
                    :inline="true"
                    style="display: flex; justify-content: space-between"
                >
                    <el-tabs v-model="tabPosition" @tab-click="(tab) => handleClick(tab, form)" style="margin-right: 10px">
                        <el-tab-pane label="今日" name="today"></el-tab-pane>
                        <el-tab-pane label="昨日" name="zuori"></el-tab-pane>
                        <el-tab-pane label="本月" name="benyue"></el-tab-pane>
                        <el-tab-pane label="上月" name="shangyue"></el-tab-pane>
                    </el-tabs>
                </el-form>
            </div>
            <div class="right">
                <el-button @click="freshen">{{ $t('common.refresh') }}</el-button>
                <el-button @click="IsShowClick">{{ $t('common.filter') }}</el-button>
                <el-button @click="outExcel">{{ $t('common.export') }}</el-button>
            </div>
        </div>

        <!-- ========== DRAWER 模式：筛选抽屉 ========== -->
        <el-drawer v-if="filterMode === 'drawer'" :title="$t('common.filter')" :visible.sync="outData_IsShow" direction="rtl" size="38%">
            <div class="drawer-wrapper">
                <el-form
                    :model="form"
                    :rules="computedRules"
                    ref="ruleForm"
                    label-position="top"
                    :inline="true"
                    style="display: flex; flex-wrap: wrap"
                >
                    <template v-for="(item, index) in allArr.item">
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style="width: 48%"
                            :key="'dI' + index"
                            v-if="(item.type == 'select' || item.type == 'select-multiple') && item.status == 1"
                        >
                            <mySelectOptimized
                                v-model="form[item.item_no]"
                                :options="allArr.value[item.item_no.replace('_no', '')] || []"
                                :values="item.item_no.replace('_no', '') + '_no'"
                                :labels="item.item_no.replace('_no', '') + '_name'"
                                :keys="item.item_no.replace('_no', '') + '_no'"
                                :multiple="item.type == 'select-multiple'"
                                :clearables="true"
                                :placeholders="'请选择' + item.item_name"
                                size="mini"
                                @selectChange="changeData(item, item.type)"
                                @clear="handleClear(item)"
                                style="width: 100%"
                            />
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            style="width: 48%"
                            :key="'dT' + index"
                            v-else-if="(item.type == 'number' || item.type == 'text') && item.status == 1"
                        >
                            <el-input
                                v-model="form[item.item_no]"
                                :type="item.type"
                                :placeholder="'请输入' + item.item_name"
                                style="width: 100%"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :label="item.item_name"
                            v-else-if="item.type == 'switch' && item.status == 1"
                            :key="'dS' + index"
                            style="width: 48%"
                        >
                            <el-tag :type="form[item.item_no] == '1' ? 'success' : form[item.item_no] == '0' ? 'danger' : ''">{{ form[item.item_no] == 1 ? '是' : '否' }}</el-tag>
                            <el-switch style="margin-left: 5px" v-model="form[item.item_no]" :active-value="1" :inactive-value="0"></el-switch>
                        </el-form-item>
                        <el-form-item
                            :prop="item.ismust == 1 ? item.item_no : null"
                            :key="'dD' + index"
                            :label="item.item_name"
                            style="width: 48%"
                            v-else-if="item.status == 1 && ['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)"
                        >
                            <el-date-picker
                                v-bind="getDatePickerProps(item)"
                                v-model="form[item.item_no]"
                                @blur="(value) => getTimes(value, item)"
                                @change="(value) => changeTime(value, item)"
                            />
                        </el-form-item>
                    </template>
                </el-form>
                <div class="filter-footer">
                    <el-button @click="outData_IsShow = false">{{ $t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="searchIt()">{{ $t('common.confirm') }}</el-button>
                </div>
            </div>
        </el-drawer>

        <!-- ========== 汇总表 table0（flex:4） ========== -->
        <template>
            <div>
                <div style="display: flex; margin-top: 10px" v-if="Object.keys(dtlArrTotal).length > 0">
                    <div style="background: white; flex: 4; padding: 20px; border-radius: 8px">
                        <div class="inbound" style="display: flex; justify-content: space-between">
                            <p style="font-size: 14px" @click="shouinbound = !shouinbound" class="title">
                                {{ dtlArrTotal.name || '' }}
                                <i class="el-icon-caret-right" v-if="!shouinbound"></i>
                                <i class="el-icon-caret-bottom" v-else></i>
                            </p>
                            <div>
                                <el-button @click="changeTable(dtlArrTotal.head, 'total')" icon="el-icon-setting"></el-button>
                            </div>
                        </div>

                        <template>
                            <div class="selectTableBoxTotal" v-show="shouinbound">
                                <el-table
                                    border
                                    height="250"
                                    :data="dtlArrTotal.data || []"
                                    style="width: 100%; margin-top: 5px; font-size: 14px"
                                    :summary-method="(param) => getSummaries(param, dtlArrTotal, systemSet)"
                                    show-summary
                                    :key="'total_' + refushTable"
                                >
                                    <template slot="empty">
                                        <div style="display: flex; justify-content: center; align-items: center; height: 250px">
                                            <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                                        </div>
                                    </template>
                                    <el-table-column
                                        v-for="(item, index) in dtlArrTotal.head"
                                        :key="index"
                                        :prop="item.field"
                                        :label="item.title"
                                        :width="item.field == 'seq' ? 50 : 160"
                                        :align="item.field == 'seq' ? 'center' : 'left'"
                                        :sortable="item.issort == 1"
                                        v-if="item.status == 1"
                                        :sort-method="(a, b) => a[item.field] - b[item.field]"
                                    >
                                        <template v-slot="scope">
                                            <div v-if="item.field == 'bill_no'">
                                                <el-button type="text" @click="handleDetails(scope.row)">
                                                    {{ scope.row.bill_no }}
                                                </el-button>
                                            </div>
                                            <div v-else>
                                                {{ scope.row[item.field] }}
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <!-- ========== 明细表 ========== -->
            <div style="margin-top: 10px">
                <div>
                    <!-- 第一行：table1 (40%) + table2 (60%) -->
                    <div style="display: flex; width: 100%">
                        <div style="background: white; width: 40%; border-radius: 8px">
                            <template v-if="dtlArrDtl.table1">
                                <div class="selectTableBox">
                                    <div style="display: flex; justify-content: space-between">
                                        <p style="font-size: 14px">{{ dtlArrDtl.table1.name }}</p>
                                        <div>
                                            <el-button @click="changeTable(dtlArrDtl.table1.head, 'table1')" icon="el-icon-setting"></el-button>
                                        </div>
                                    </div>
                                    <el-table
                                        border
                                        height="500"
                                        :data="getTableData('table1')"
                                        style="width: 100%; margin-top: 5px; font-size: 14px"
                                        :summary-method="(param) => getSummaries(param, dtlArrDtl.table1, systemSet)"
                                        show-summary
                                    >
                                        <el-table-column
                                            v-for="(item, index) in dtlArrDtl.table1.head"
                                            :key="index"
                                            :prop="item.field"
                                            :label="item.title"
                                            :width="item.field == 'seq' ? 50 : 160"
                                            :align="item.field == 'seq' ? 'center' : 'left'"
                                            :sortable="item.issort == 1"
                                            v-if="item.status == 1"
                                            :sort-method="(a, b) => a[item.field] - b[item.field]"
                                        >
                                            <template v-slot="scope">
                                                <div v-if="item.field == 'bill_no'">
                                                    <el-button type="text" @click="handleDetails(scope.row)">
                                                        {{ scope.row.bill_no }}
                                                    </el-button>
                                                </div>
                                                <div v-else>
                                                    {{ scope.row[item.field] }}
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>

                                <div class="pagination">
                                    <el-pagination
                                        @size-change="(val) => handleSizeChange(val, 'table1')"
                                        @current-change="(val) => handleCurrentChange(val, 'table1')"
                                        :current-page="pagination['table1'].currentPage"
                                        :page-size="pagination['table1'].pageSize"
                                        :total="getTableTotal('table1')"
                                        layout="total, prev, pager, next"
                                    ></el-pagination>
                                </div>
                            </template>
                            <template v-else>
                                <div
                                    class="selectTableBox"
                                    style="display: flex; justify-content: center; align-items: center; height: 500px; background: white; border-radius: 8px"
                                >
                                    <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                                </div>
                            </template>
                        </div>
                        <div style="background: white; margin-left: 10px; width: 60%; border-radius: 8px">
                            <template v-if="dtlArrDtl.table2">
                                <div class="selectTableBox">
                                    <div style="display: flex; justify-content: space-between">
                                        <p style="font-size: 14px">{{ dtlArrDtl.table2.name }}</p>
                                        <div>
                                            <el-button @click="changeTable(dtlArrDtl.table2.head, 'table2')" icon="el-icon-setting"></el-button>
                                        </div>
                                    </div>
                                    <el-table
                                        border
                                        :data="getTableData('table2')"
                                        style="width: 100%; margin-top: 5px; font-size: 14px"
                                        height="500"
                                        :summary-method="(param) => getSummaries(param, dtlArrDtl.table2, systemSet)"
                                        show-summary
                                    >
                                        <el-table-column
                                            v-for="(item, index) in dtlArrDtl.table2.head"
                                            :key="index"
                                            :prop="item.field"
                                            :label="item.title"
                                            :width="item.field == 'seq' ? 50 : 160"
                                            :align="item.field == 'seq' ? 'center' : 'left'"
                                            :sortable="item.issort == 1"
                                            v-if="item.status == 1"
                                            :sort-method="(a, b) => a[item.field] - b[item.field]"
                                        >
                                            <template v-slot="scope">
                                                <div v-if="item.field == 'bill_no'">
                                                    <el-button type="text" @click="handleDetails(scope.row)">
                                                        {{ scope.row.bill_no }}
                                                    </el-button>
                                                </div>
                                                <div v-else>
                                                    {{ scope.row[item.field] }}
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="pagination">
                                    <el-pagination
                                        @size-change="(val) => handleSizeChange(val, 'table2')"
                                        @current-change="(val) => handleCurrentChange(val, 'table2')"
                                        :current-page="pagination['table2'].currentPage"
                                        :page-size="pagination['table2'].pageSize"
                                        :total="getTableTotal('table2')"
                                        layout="total, prev, pager, next"
                                    ></el-pagination>
                                </div>
                            </template>
                            <template v-else>
                                <div
                                    class="selectTableBox"
                                    style="display: flex; justify-content: center; align-items: center; height: 500px; background: white; border-radius: 8px"
                                >
                                    <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                                </div>
                            </template>
                        </div>
                    </div>

                    <!-- 第二行：table4 (40%) + table3 (60%) -->
                    <div style="display: flex; width: 100%; margin-top: 10px">
                        <div style="background: white; width: 40%; border-radius: 8px">
                            <template v-if="dtlArrDtl.table4">
                                <div class="selectTableBox">
                                    <div style="display: flex; justify-content: space-between">
                                        <p style="font-size: 14px">{{ dtlArrDtl.table4.name }}</p>
                                        <div>
                                            <el-button @click="changeTable(dtlArrDtl.table4.head, 'table4')" icon="el-icon-setting"></el-button>
                                        </div>
                                    </div>
                                    <el-table
                                        border
                                        height="500"
                                        :data="getTableData('table4')"
                                        style="width: 100%; margin-top: 5px; font-size: 14px"
                                        :summary-method="(param) => getSummaries(param, dtlArrDtl.table4, systemSet)"
                                        show-summary
                                    >
                                        <el-table-column
                                            v-for="(item, index) in dtlArrDtl.table4.head"
                                            :key="index"
                                            :prop="item.field"
                                            :label="item.title"
                                            :width="item.field == 'seq' ? 50 : 160"
                                            :align="item.field == 'seq' ? 'center' : 'left'"
                                            :sortable="item.issort == 1"
                                            v-if="item.status == 1"
                                            :sort-method="(a, b) => a[item.field] - b[item.field]"
                                        >
                                            <template v-slot="scope">
                                                <div v-if="item.field == 'bill_no'">
                                                    <el-button type="text" @click="handleDetails(scope.row)">
                                                        {{ scope.row.bill_no }}
                                                    </el-button>
                                                </div>
                                                <div v-else>
                                                    {{ scope.row[item.field] }}
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>

                                <div class="pagination">
                                    <el-pagination
                                        @size-change="(val) => handleSizeChange(val, 'table4')"
                                        @current-change="(val) => handleCurrentChange(val, 'table4')"
                                        :current-page="pagination['table4'].currentPage"
                                        :page-size="pagination['table4'].pageSize"
                                        :total="getTableTotal('table4')"
                                        layout="total, prev, pager, next"
                                    ></el-pagination>
                                </div>
                            </template>
                            <template v-else>
                                <div
                                    class="selectTableBox"
                                    style="display: flex; justify-content: center; align-items: center; height: 500px; background: white; border-radius: 8px"
                                >
                                    <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                                </div>
                            </template>
                        </div>
                        <div style="background: white; margin-left: 10px; width: 60%; border-radius: 8px">
                            <template v-if="dtlArrDtl.table3">
                                <div class="selectTableBox">
                                    <div style="display: flex; justify-content: space-between">
                                        <p style="font-size: 14px">{{ dtlArrDtl.table3.name }}</p>
                                        <div>
                                            <el-button @click="changeTable(dtlArrDtl.table3.head, 'table3')" icon="el-icon-setting"></el-button>
                                        </div>
                                    </div>
                                    <el-table
                                        border
                                        :data="getTableData('table3')"
                                        style="width: 100%; margin-top: 5px; font-size: 14px"
                                        height="500"
                                        :summary-method="(param) => getSummaries(param, dtlArrDtl.table3, systemSet)"
                                        show-summary
                                    >
                                        <el-table-column
                                            v-for="(item, index) in dtlArrDtl.table3.head"
                                            :key="index"
                                            :prop="item.field"
                                            :label="item.title"
                                            :width="item.field == 'seq' ? 50 : 160"
                                            :align="item.field == 'seq' ? 'center' : 'left'"
                                            :sortable="item.issort == 1"
                                            v-if="item.status == 1"
                                            :sort-method="(a, b) => a[item.field] - b[item.field]"
                                        >
                                            <template v-slot="scope">
                                                <div v-if="item.field == 'bill_no'">
                                                    <el-button type="text" @click="handleDetails(scope.row)">
                                                        {{ scope.row.bill_no }}
                                                    </el-button>
                                                </div>
                                                <div v-else>
                                                    {{ scope.row[item.field] }}
                                                </div>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div class="pagination">
                                    <el-pagination
                                        @size-change="(val) => handleSizeChange(val, 'table3')"
                                        @current-change="(val) => handleCurrentChange(val, 'table3')"
                                        :current-page="pagination['table3'].currentPage"
                                        :page-size="pagination['table3'].pageSize"
                                        :total="getTableTotal('table3')"
                                        layout="total, prev, pager, next"
                                    ></el-pagination>
                                </div>
                            </template>
                            <template v-else>
                                <div
                                    class="selectTableBox"
                                    style="display: flex; justify-content: center; align-items: center; height: 500px; background: white; border-radius: 8px"
                                >
                                    <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- ========== 列配置抽屉 ========== -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false">
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.title }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="'opt_' + index"
                                        v-show="item.status == 0"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.title }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { getColumnTitleByLang } from '@/utils/columnI18n';
import { apiGetListCorrespondingReportData } from '@/request/api';
export default {
    name: 'ReportTableChildrenAll',
    props: {
        apiConfig: {
            type: Object,
            required: true,
            default: () => ({
                pull: null,
                getData: null,
                exportData: null
            })
        },
        dateField: {
            type: String,
            default: 'billDateRange'
        },
        showTabs: {
            type: Boolean,
            default: true
        },
        filterMode: {
            type: String,
            default: 'drawer',
            validator: (val) => ['inline', 'drawer'].includes(val)
        }
    },
    data() {
        let self = this;
        return {
            originalHead: {},
            originalItems: [],
            keyList: [],
            currentTableKey: '',
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            missingFields: '',
            mulStyle: '',
            outData_IsShow: false,
            tabPosition: 'today',
            shouinbound: true,
            dtlArrTotal: {},
            dtlArrDtl: {},
            allArr: { item: [], value: {} },
            title_name: '',
            form: {
                billDateRange: []
            },
            pagination: {
                table1: { currentPage: 1, pageSize: 10 },
                table2: { currentPage: 1, pageSize: 10 },
                table3: { currentPage: 1, pageSize: 10 },
                table4: { currentPage: 1, pageSize: 10 }
            },
            systemSet: JSON.parse(localStorage.getItem('systemSet') || '{}'),
            dateTime: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            if (self.tabPosition !== 'today') { self.tabPosition = 'today'; }
                            const end = new Date();
                            const start = new Date();
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 59, 59, 999);
                            self.dateTime = [start, end];
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '昨日',
                        onClick(picker) {
                            if (self.tabPosition !== 'zuori') { self.tabPosition = 'zuori'; }
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24);
                            start.setHours(0, 0, 0, 0);
                            end.setHours(23, 59, 59, 999);
                            self.dateTime = [start, end];
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '本月',
                        onClick(picker) {
                            if (self.tabPosition !== 'benyue') { self.tabPosition = 'benyue'; }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();
                            const start = new Date(currentYear, currentMonth, 1);
                            const end = new Date(currentYear, currentMonth + 1, 0);
                            end.setHours(23, 59, 59, 999);
                            self.dateTime = [start, end];
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            if (self.tabPosition !== 'shangyue') { self.tabPosition = 'shangyue'; }
                            let currentDate = new Date();
                            let currentMonth = currentDate.getMonth();
                            let currentYear = currentDate.getFullYear();
                            if (currentMonth === 0) { currentMonth = 11; currentYear--; } else { currentMonth--; }
                            const start = new Date(currentYear, currentMonth, 1);
                            const end = new Date(currentYear, currentMonth + 1, 0);
                            end.setHours(23, 59, 59, 999);
                            self.dateTime = [start, end];
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    watch: {
        '$i18n.locale'() {
            this.updateColumnTitles();
            this.updateFormItemNames();
        }
    },
    created() {
        const today = this.formatDate(new Date());
        this.form[this.dateField] = [today, today];
        this.getPull();
    },
    computed: {
        computedRules() {
            const rules = {};
            if (this.allArr.item) {
                this.allArr.item.forEach((item) => {
                    if (item.ismust == 1) {
                        if (['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)) {
                            rules[item.item_no] = [{ required: true, message: `请选择${item.item_name}`, trigger: 'change' }];
                        } else if (['select', 'switch', 'select-multiple'].includes(item.type)) {
                            rules[item.item_no] = [{ required: true, message: `请选择${item.item_name}`, trigger: 'change' }];
                        } else {
                            rules[item.item_no] = [{ required: true, message: `${item.item_name}不能为空`, trigger: 'blur' }];
                        }
                    }
                });
            }
            return rules;
        }
    },
    methods: {
        updateColumnTitles() {
            const lang = this.$i18n ? this.$i18n.locale : 'zh-CN';
            if (this.dtlArrTotal && this.dtlArrTotal.head && this.originalHead.total) {
                this.dtlArrTotal.head = this.originalHead.total.map(item => ({ ...item, title: getColumnTitleByLang(item, lang, 'title') }));
            }
            Object.keys(this.originalHead).forEach(key => {
                if (key === 'total') return;
                if (this.dtlArrDtl[key] && this.originalHead[key]) {
                    this.dtlArrDtl[key].head = this.originalHead[key].map(item => ({ ...item, title: getColumnTitleByLang(item, lang, 'title') }));
                }
            });
        },
        updateFormItemNames() {
            if (!this.allArr || !this.allArr.item || !this.originalItems.length) return;
            const lang = this.$i18n ? this.$i18n.locale : 'zh-CN';
            this.allArr.item = this.originalItems.map(item => ({ ...item, item_name: getColumnTitleByLang(item, lang, 'item_name') }));
        },
        getTableData(type) {
            if (!this.dtlArrDtl || !this.dtlArrDtl[type] || !Array.isArray(this.dtlArrDtl[type].data)) {
                return [];
            }
            const currentPage = this.pagination[type].currentPage || 1;
            const pageSize = this.pagination[type].pageSize || 10;
            const start = (currentPage - 1) * pageSize;
            return this.dtlArrDtl[type].data.slice(start, start + pageSize);
        },
        getTableTotal(type) {
            const table = this.dtlArrDtl && this.dtlArrDtl[type];
            if (!table) return 0;
            if (table.count != null) return table.count;
            return Array.isArray(table.data) ? table.data.length : 0;
        },
        handleSizeChange(val, type) {
            this.pagination[type].pageSize = val;
        },
        handleCurrentChange(val, type) {
            this.pagination[type].currentPage = val;
        },
        changeTable(data, tableKey) {
            this.currentTableKey = tableKey;
            this.drawers = true;
            this.keyList = data;
        },
        liClick(type, item, index) {
            if (type === 'del') { this.$set(this.keyList[index], 'status', '0'); }
            else if (type === 'add') { this.$set(this.keyList[index], 'status', '1'); }
        },
        checkMove() {},
        keycancel() {
            this.drawers = false;
            this.getData();
            this.currentTableKey = '';
        },
        keyConfirm() {
            if (this.keyList) {
                apiGetListCorrespondingReportData({ head: this.keyList }).then((res) => {
                    this.drawers = false;
                    if (res.code == 2000) {
                        this.$message.success(res.msg);
                        this.refushTable = !this.refushTable;
                        this.getData();
                        this.currentTableKey = '';
                    } else if (res.code == 4000) {
                        this.$message.warning(res.data.info);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }
        },
        getDatePickerProps(item) {
            const baseProps = { style: 'width: 99%', placeholder: '选择' + item.item_name };
            switch (item.type) {
                case 'date': return { ...baseProps, type: 'date', valueFormat: 'yyyy-MM-dd' };
                case 'datetime': return { ...baseProps, type: 'datetime', valueFormat: 'yyyy-MM-dd HH:mm:ss' };
                case 'daterange': return { ...baseProps, type: 'daterange', valueFormat: 'yyyy-MM-dd', startPlaceholder: '开始日期', endPlaceholder: '结束日期', defaultTime: ['00:00:00', '23:59:59'], pickerOptions: this.pickerOptions };
                case 'datetimerange': return { ...baseProps, type: 'datetimerange', valueFormat: 'yyyy-MM-dd HH:mm:ss', startPlaceholder: '开始日期', endPlaceholder: '结束日期', defaultTime: ['00:00:00', '23:59:59'], pickerOptions: this.pickerOptions };
                default: return {};
            }
        },
        freshen() {
            if (Array.isArray(this.missingFields)) {
                const allFieldsHaveValue = this.missingFields.every((field) => this.form && this.form[field] && this.form[field] !== '');
                if (allFieldsHaveValue) { this.searchIt(); } else { this.getPull(); }
            }
            this.freSplit();
        },
        freSplit() {
            if (this.mulStyle) {
                this.mulStyle.forEach((key) => {
                    let value = this.form[key];
                    if (typeof value == 'string' && value) {
                        this.form[key] = value.split(',');
                    }
                });
            }
        },
        IsShowClick() {
            this.outData_IsShow = true;
            if (this.mulStyle) {
                this.mulStyle.forEach((key) => {
                    let value = this.form[key];
                    if (typeof value == 'string') {
                        if (value) { this.form[key] = value.split(','); }
                    }
                });
            }
        },
        handleDetails(row) {
            if (row.allow_use == '0') {
                this.$message.error('暂无权限');
                return;
            }
            if (row.bill_code) {
                this.$router.push({ path: '/' + row.bill_code, query: { bill_no: row.bill_no } });
            }
        },
        changeTime(val, row) {
            if (val == null || (Array.isArray(val) && val.length === 0)) {
                setTimeout(() => {
                    const today = this.formatDate(new Date());
                    this.form[row.item_no] = [today, today];
                    this.dateTime = [today, today];
                    this.tabPosition = 'today';
                }, 500);
            } else {
                this.tabPosition = '';
            }
        },
        getTimes(event, row) {
            if (!this.form[row.item_no]) { this.$set(this.form, row.item_no, []); }
            if (event && event.displayValue && event.displayValue.length === 2) {
                this.form[row.item_no] = [event.displayValue[0], event.displayValue[1]];
            }
        },
        formatDate(date) {
            if (!date) return '';
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            if (month < 10) month = `0${month}`;
            if (day < 10) day = `0${day}`;
            return `${year}-${month}-${day}`;
        },
        handleClick(tab, row) {
            const fieldName = this.dateField;
            if (!Array.isArray(this.form[fieldName])) { this.$set(this.form, fieldName, []); }
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth();
            const day = date.getDate();
            let tabName = tab.name || tab;
            if (tabName == 'today') {
                this.form[fieldName][0] = this.formatDate(new Date());
                this.form[fieldName][1] = this.formatDate(new Date());
                this.tabPosition = 'today';
            } else if (tabName == 'zuori') {
                this.form[fieldName][0] = this.formatDate(new Date(year, month, day - 1));
                this.form[fieldName][1] = this.formatDate(new Date(year, month, day - 1));
                this.tabPosition = 'zuori';
            } else if (tabName == 'benyue') {
                this.form[fieldName][0] = this.formatDate(new Date(year, month, 1));
                this.form[fieldName][1] = this.formatDate(new Date(year, month + 1, 0));
                this.tabPosition = 'benyue';
            } else if (tabName == 'shangyue') {
                this.form[fieldName][0] = this.formatDate(new Date(year, month - 1, 1));
                this.form[fieldName][1] = this.formatDate(new Date(year, month, 0));
                this.tabPosition = 'shangyue';
            }
            this.form[fieldName] = [this.form[fieldName][0], this.form[fieldName][1]];
            this.dateTime = [this.form[fieldName][0], this.form[fieldName][1]];
            if (!row || !this.allArr.item || this.allArr.item.length === 0) { return; }
            let missingFieldsData = [];
            let missingFields = [];
            this.allArr.item.forEach((item) => {
                if (item.ismust == 1) {
                    const fieldValue = row[item.item_no];
                    if (!fieldValue || fieldValue == '' || fieldValue == null || (Array.isArray(fieldValue) && fieldValue.length == 0)) {
                        missingFieldsData.push(item.item_name);
                        missingFields.push(item.item_no);
                    }
                }
            });
            this.missingFields = missingFields;
            if (missingFieldsData.length > 0 && missingFields.filter((field) => field !== fieldName).length > 0) {
                this.outData_IsShow = true;
                this.$message.error(`以下字段是必选项，请填写或选择${missingFieldsData.join(', ')}`);
            } else {
                this.searchIt();
            }
        },
        getPull() {
            if (typeof this.apiConfig.pull !== 'function') { this.searchIt(); return; }
            this.$load.show();
            this.apiConfig.pull({}).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.allArr = res.data;
                    this.title_name = res.module;
                    this.originalItems = res.data.item ? JSON.parse(JSON.stringify(res.data.item)) : [];
                    this.updateFormItemNames();
                    if (this.showTabs && this.filterMode === 'drawer') {
                        this.handleClick('today', this.allArr);
                    } else {
                        this.searchIt();
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            }).catch(() => { this.$load.close(); this.searchIt(); });
        },
        handleClear(item) { this.form[item.item_no] = ''; },
        changeData(row, e) {
            if (e == 'select-multiple') {
                if (!this.mulStyle) { this.mulStyle = new Set(); }
                this.mulStyle.add(row.item_no);
            }
        },
        searchIt() {
            Object.keys(this.pagination).forEach((key) => {
                this.pagination[key].currentPage = 1;
            });
            this.getData();
        },
        getData() {
            let data = JSON.parse(JSON.stringify(this.form));
            Object.keys(data).forEach((key) => {
                if (Array.isArray(data[key]) && data[key].length === 0) { delete data[key]; }
                else if (data[key] === '' || data[key] === null || data[key] === undefined) { delete data[key]; }
            });
            if (this.mulStyle) {
                this.mulStyle.forEach((key) => {
                    if (Array.isArray(data[key])) { data[key] = data[key].join(','); }
                });
            }
            if (typeof this.apiConfig.getData !== 'function') { this.$message.warning('未配置数据接口'); return; }
            this.$load.show();
            this.apiConfig.getData(data).then((res) => {
                if (res.code == 2000) {
                    this.outData_IsShow = false;
                    this.dtlArrTotal = (res.data && res.data.table0) || {};
                    this.dtlArrDtl = res.data || {};
                    this.cacheOriginalHeads();
                    this.updateColumnTitles();
                    this.$message.success(res.msg);
                } else {
                    this.dtlArrTotal = {};
                    this.dtlArrDtl = {};
                    this.$message.error(res.data.info);
                }
                this.freSplit();
                this.$load.close();
            }).catch(() => {
                this.$load.close();
                this.dtlArrTotal = {};
                this.dtlArrDtl = {};
            });
        },
        cacheOriginalHeads() {
            this.originalHead = {};
            if (this.dtlArrTotal && this.dtlArrTotal.head) {
                this.originalHead.total = JSON.parse(JSON.stringify(this.dtlArrTotal.head));
            }
            Object.keys(this.dtlArrDtl).forEach(key => {
                if (key.startsWith('table') && this.dtlArrDtl[key] && this.dtlArrDtl[key].head) {
                    this.originalHead[key] = JSON.parse(JSON.stringify(this.dtlArrDtl[key].head));
                }
            });
        },
        outExcel() {
            if (typeof this.apiConfig.exportData !== 'function') { this.$message.warning('未配置导出接口'); return; }
            this.$load.show();
            let data = JSON.parse(JSON.stringify(this.form));
            data.login_staff = localStorage.getItem('ms_username');
            data.is_exports = 1;
            if (this.mulStyle) {
                this.mulStyle.forEach((key) => { if (Array.isArray(data[key])) { data[key] = data[key].join(','); } });
            }
            this.apiConfig.exportData(data).then((res) => {
                let blob = new Blob([res.data], { type: 'application/x-xls' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = this.title_name + '.xlsx';
                link.click();
                this.$load.close();
            }).catch(() => { this.$load.close(); });
        },
        getSummaries(param, dtlArr, systemSet) {
            const { columns, data } = param;
            const sums = [];
            if (!dtlArr || !dtlArr.head) return sums;
            const sumHead = (dtlArr.head || []).filter((item) => item.issum == 1);
            const sumFields = new Set(sumHead.map((item) => item.field));
            const fmtnumToDecimalPlaces = { qty: systemSet.qty, amt: systemSet.amt, rate: systemSet.rate, wgt: systemSet.wgt };
            columns.forEach((column, index) => {
                if (index === 0) { sums[index] = '合计'; return; }
                if (!sumFields.has(column.property)) { return; }
                const columnDataValues = data.map((item) => {
                    let value = item[column.property] || '0';
                    return Number(value.toString().replace(/,/g, ''));
                });
                if (columnDataValues.every((value) => isNaN(value))) { sums[index] = ''; return; }
                let sum = columnDataValues.reduce((prev, curr) => (isNaN(curr) ? prev : prev + curr), 0);
                const headItem = sumHead.find((item) => item.field === column.property);
                const decimalPlaces = (headItem && fmtnumToDecimalPlaces[headItem.fmtNum]) || 0;
                const fixed = sum.toFixed(decimalPlaces);
                const [integerPart, decimalPart] = fixed.split('.');
                const withCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                sums[index] = decimalPart ? `${withCommas}.${decimalPart}` : withCommas;
            });
            return sums;
        }
    }
};
</script>

<style lang="scss" scoped>
.big_box {
    // background: #fff;
    // padding: 20px;
}
.header_warpper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 25px;
    height: 50px;
    .left {
        display: flex;
        align-items: center;
    }
}
/deep/.el-tabs__nav-wrap::after {
    background-color: #fff;
}
/deep/.el-tabs__item {
    width: 66px;
    text-align: center;
    padding: 0;
    font-size: 12px;
}
/deep/.el-tabs__active-bar {
    width: 66px !important;
}
.selectTableBox {
    background: #fff;
    padding: 20px;

    // 合计行样式
    /deep/ .has-gutter tr td .cell:empty::before {
        // content: '';
    }
    /deep/ .el-table__footer-wrapper tbody td,
    .el-table__header-wrapper tbody td {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__footer-wrapper .is-leaf {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__fixed-footer-wrapper tbody td {
        // border-top: 1px solid #ebeef5;
        // background-color: #e3f3ff;
        // font-weight: bold;
        color: #f50b0b;
        // text-align: center !important;
    }
    /deep/ .has-gutter tr td .cell {
        // text-align: center;
        font-weight: bold;
        color: #f50b0b;
    }

    /deep/ .el-table {
        display: flex;
        flex-direction: column;
    }

    /* order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 */
    /deep/ .el-table__body-wrapper {
        order: 0;
    }

    // 若没有固定列，以下代码可以不写
    // 将固定列放在首行
    /deep/ .el-table__fixed-body-wrapper {
        // top: 96px !important; // 根据自己的项目进行微调
    }

    /deep/ .el-table__fixed-footer-wrapper {
        font-weight: bold;
        // z-index: 0;
        // top: 48px; // 根据自己的项目进行微调
    }
}
.selectTableBoxTotal {
    background: #fff;
    margin-top: 10px;
    // 合计行样式
    /deep/ .has-gutter tr td .cell:empty::before {
        // content: '';
    }
    /deep/ .el-table__footer-wrapper tbody td,
    .el-table__header-wrapper tbody td {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__footer-wrapper .is-leaf {
        // background-color: #e3f3ff !important;
    }
    /deep/ .el-table__fixed-footer-wrapper tbody td {
        // border-top: 1px solid #ebeef5;
        // background-color: #e3f3ff;
        // font-weight: bold;
        color: #f50b0b;
        // text-align: center !important;
    }
    /deep/ .has-gutter tr td .cell {
        // text-align: center;
        font-weight: bold;
        color: #f50b0b;
    }

    /deep/ .el-table {
        display: flex;
        flex-direction: column;
    }

    /* order默认值为0，只需将表体order置为1即可移到最后，这样合计行就上移到表体上方 */
    /deep/ .el-table__body-wrapper {
        order: 0;
    }

    // 若没有固定列，以下代码可以不写
    // 将固定列放在首行
    /deep/ .el-table__fixed-body-wrapper {
        // top: 96px !important; // 根据自己的项目进行微调
    }

    /deep/ .el-table__fixed-footer-wrapper {
        font-weight: bold;
        // z-index: 0;
        // top: 48px; // 根据自己的项目进行微调
    }
}
.inbound {
    width: 100%;
    background-color: #fff;
    .title {
        cursor: pointer;
        i {
            color: #409eff;
        }
    }
}
.pagination {
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
}
.drawer-wrapper {
    padding: 10px;
}
.filter-footer {
    padding: 12px 0;
    text-align: right;
}
// .filterKey_box {
//     .box_header {
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         padding: 15px;
//         border-bottom: 1px solid #ebeef5;
//         font-size: 16px;
//         font-weight: bold;
//         .icon { cursor: pointer; font-size: 18px; }
//     }
//     .box_content {
//         padding: 10px;
//         .small_box {
//             margin-bottom: 20px;
//             .text {
//                 display: flex;
//                 justify-content: space-between;
//                 padding: 10px;
//                 font-weight: bold;
//                 .small { font-weight: normal; color: #909399; font-size: 12px; }
//             }
//             .ul {
//                 list-style: none;
//                 padding: 0;
//                 margin: 0;
//                 max-height: 300px;
//                 overflow-y: auto;
//                 .li {
//                     display: flex;
//                     align-items: center;
//                     padding: 10px 15px;
//                     border: 1px solid #ebeef5;
//                     border-radius: 4px;
//                     margin-bottom: 5px;
//                     cursor: pointer;
//                     background: #fff;
//                     transition: all 0.3s;
//                     .icon, .icon2 { margin-right: 8px; color: #606266; }
//                     .delIcon { margin-left: auto; color: #f50b0b; }
//                     &:hover { background: #ecf5ff; border-color: #409eff; }
//                     &.hover { background: #f5f7fa; }
//                 }
//             }
//         }
//         .box_btn {
//             display: flex;
//             justify-content: flex-end;
//             padding: 15px;
//             border-top: 1px solid #ebeef5;
//             button { margin-left: 10px; }
//         }
//     }
// }
</style>
